import type { MetrikaGoalId } from './metrikaGoals';

const TAG_JS_BASE = 'https://mc.yandex.ru/metrika/tag.js';

let initializedCounterId: number | null = null;

export const getYandexMetrikaCounterId = (): number | null => {
    const raw = process.env.REACT_APP_YM_COUNTER_ID?.trim();
    if (!raw) {
        return null;
    }

    const counterId = Number(raw);
    if (!Number.isInteger(counterId) || counterId <= 0) {
        return null;
    }

    return counterId;
};

const ensureYmStub = (): void => {
    if (typeof window.ym === 'function') {
        return;
    }

    const ymStub: YandexMetrikaFn = function (...args: unknown[]) {
        (ymStub.a = ymStub.a ?? []).push(args as YandexMetrikaCommand);
    };

    ymStub.l = Date.now();
    window.ym = ymStub;
};

const loadMetrikaScript = (counterId: number): void => {
    const scriptSrc = `${TAG_JS_BASE}?id=${counterId}`;

    if (document.querySelector(`script[src="${scriptSrc}"]`)) {
        return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = scriptSrc;
    document.head.appendChild(script);
};

export const initYandexMetrika = (): void => {
    if (typeof window === 'undefined') {
        return;
    }

    const counterId = getYandexMetrikaCounterId();
    if (counterId === null || initializedCounterId === counterId) {
        return;
    }

    ensureYmStub();
    loadMetrikaScript(counterId);

    window.ym?.(counterId, 'init', {
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: 'dataLayer',
        accurateTrackBounce: true,
        trackLinks: true,
    });

    initializedCounterId = counterId;
};

export const reachMetrikaGoal = (
    goal: MetrikaGoalId | (string & {}),
    params?: Record<string, unknown>
): void => {
    const counterId = getYandexMetrikaCounterId();
    if (counterId === null || typeof window.ym !== 'function') {
        return;
    }

    if (params) {
        window.ym(counterId, 'reachGoal', goal, params);
        return;
    }

    window.ym(counterId, 'reachGoal', goal);
};
